import {
  Empty,
  Flex,
  Grid,
  Heading,
  Spacer,
  Text,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import {
  IObject,
} from 'common/interfaces/hierarchy-entities';
import { useTranslation } from 'react-i18next';

interface IProjectDataComponentProps {
  dataObject: IObject;
}

export const ProjectData = ({ dataObject }: IProjectDataComponentProps) => {
  const { t } = useTranslation();

  const renderProjectData = () => {
    const { hierarchyData } = dataObject.metadata;

    if (!hierarchyData) {
      return (
        <Flex justifyContent="center" alignItems="center">
          <Empty text="Legacy object with no data" />
        </Flex>
      );
    }

    const countryname = hierarchyData?.country?.name;
    const fieldname = hierarchyData.field?.name;
    const sitename = hierarchyData.site?.name;
    const wellname = hierarchyData.well.name;
    const wellborename = hierarchyData.wellbore?.name;
    const designname = hierarchyData?.design.name;

    return (
      <Grid columns="32% 68%" gap="var(--padding-xs)">
        <>
          <Text bold>{t(translations.country)}</Text>
          <Text>{countryname}</Text>
        </>
        <>
          <Text bold>{t(translations.field)}</Text>
          <Text>{fieldname}</Text>
        </>
        <>
          <Text bold>{t(translations.site)}</Text>
          <Text>{sitename}</Text>
        </>
        <>
          <Text bold>{t(translations.well)}</Text>
          <Text>{wellname}</Text>
        </>
        <>
          <Text bold>{t(translations.wellbore)}</Text>
          <Text>{wellborename}</Text>
        </>
        <>
          <Text bold>{t(translations.design)}</Text>
          <Text>{designname}</Text>
        </>
      </Grid>
    );
  };

  return (
    <div>
      <Heading>{t(translations.edm_projectData)}</Heading>
      <Spacer />
      {renderProjectData()}
    </div>
  );
};
